import React from "react";
import { Box, Image } from "@chakra-ui/react";
import { ManagerLogoProps } from "./ManagerLogo.types";

export const ManagerLogo: React.FC<ManagerLogoProps> = ({
  manager,
  size = 55,
  ...rest
}) => {
  return (
    <Box
      w={`${size}px`}
      h={`${size}px`}
      bg={"bg.grey"}
      overflow={"hidden"}
      borderRadius={4}
      {...rest}
    >
      <Image
        borderRadius={4}
        src={manager.imgUrl || manager.logoUrl || ""}
        alt={`${manager.name}'s logo`}
      />
    </Box>
  );
};
